import { Injectable } from '@angular/core';
import { BaseDataService, DataService } from '../core/services';
import { API_URL } from '../constants';
import { Observable } from 'rxjs';

@Injectable()
export class IncidentAccidentServiceService extends BaseDataService {

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public GetAll(selectedDate: string,
        toDay: string,
        accidentType: number,
        siteId: number,
        typeData: number,
        searchText: string,
        status: number,
        accountId: number,
        userId: number,
        moduleId: number): Observable<any> {
        let url = `IncidentAccident/GetAll?selectedDate=${selectedDate}&toDay=${toDay}&accidentType=${accidentType}&siteId=${siteId}&typeData=${typeData}&searchText=${searchText}&status=${status}&accountId=${accountId}&userId=${userId}&moduleId=${moduleId}`;
        return super.getAll<any>(url);
    }

    public saveIncidentAccident(data) {
        let url = `IncidentAccident/Save`;
        return super.save<any>(url, data);
    }

    public toggleClose(data) {
        let url = `IncidentAccident/ToggleClose`;
        return super.save<any>(url, data);
    }

    public GetSkadetypes(type: number, accountId: number): Observable<any> {
        let url = `IncidentAccident/GetSkadetypes?type=${type}&accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public saveSkadetype(data) {
        let url = `IncidentAccident/SaveSkadetyp`;
        return super.save<any>(url, data);
    }

    public Get(id?: number): Observable<any> {
        let url = `IncidentAccident/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetAllSkadetype(accountId: number): Observable<any> {
        let url = `IncidentAccident/GetAllSkadetypes?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public deleteData(data) {
        let url = `IncidentAccident/Delete`;
        return super.save<any>(url, data);
    }

    public DeleteComment(id: number) {
        let url = `IncidentAccident/DeleteComment?id=${id}`;
        return super.getAll<any>(url);
    }

    public DeleteSkadetyp(data) {
        let url = `IncidentAccident/DeleteSkadetyp`;
        return super.save<any>(url, data);
    }

    public AddComment(data) {
        let url = `IncidentAccident/AddComment`;
        return super.save<any>(url, data);
    }

    public GetSkadetype(id: number): Observable<any> {
        let url = `IncidentAccident/GetSkadetype?id=${id}`;
        return super.getAll<any>(url);
    }

    public DownloadReport(id: number, accountId: number, isAccident: boolean) {
        let url = `IncidentAccident/DownloadReport?id=${id}&accountId=${accountId}&isAccident=${isAccident}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public DownloadReportList(date: string, siteId: number, date1: string) {
        let url = `IncidentAccident/DownloadReportList?date=${date}&siteId=${siteId}&date1=${date1}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public ExportXLSList(model: any) {
        let url = `IncidentAccident/ExportXLSList?date=${model.Date}&siteId=${model.SiteId}&date1=${model.Date1}&type=${model.Type}&status=${model.Status}
        &search=${model.Search}&accountId=${model.AccountId}&userId=${model.UserId}&accidentType=${model.AccidentType}`;
        return super.savePDF<any>(url, 'application/pdf');
    }

}



// WEBPACK FOOTER //
// ./src/app/services/incident-accident-service.service.ts